import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  LayoutTable,
  LayoutThead,
  TableNoData,
} from "../../../components/layouts/Table";
import SectionPagination from "../../../components/sections/Pagination";
import { userState } from "../../../storage/auth";
import { FilterJenis } from "../components/Filter";
import { CeklistMonitoringContext } from "../Routes";

const Auditee = ({ mainUrl, onFetchData }) => {
  const user = useRecoilValue(userState);
  const {
    ceklistMonitoring,
    setPage,
    setType,
    cabang,
    departemen,
    auditor,
    isLoaded,
    setIsLoaded,
  } = useContext(CeklistMonitoringContext);

  useEffect(() => {
    onFetchData({ auditee_id: user.id });
    return () => {
      setIsLoaded(false);
    };
  }, [onFetchData, setIsLoaded, user.id]);

  return (
    <>
      <div className="row">
        <div className="col-6 mb-2">
          <FilterJenis onChange={(res) => setType(res)} />
        </div>
      </div>
      <LayoutTable>
        <LayoutThead>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">no</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">cabang</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">departemen</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">auditor</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">tahun</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">tahap</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">kode_dokumen</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">revisi</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">tanggal_efektif</th>
          <th className="py-1 bg-primary text-white border-bottom border-silver fw-normal">
            <span className="fa fa-fw fa-cog"></span>
          </th>
        </LayoutThead>
        <tbody>
          {isLoaded &&
          ceklistMonitoring.data &&
          ceklistMonitoring.data.length > 0 ? (
            ceklistMonitoring.data.map((cm, index) => {
              return (
                <tr key={index}>
                  <td className="py-1 border-silver text-nowrap text-center">{index + 1}</td>
                  <td className="py-1 border-silver text-nowrap text-center">
                    {cabang.length > 0 &&
                      cabang
                        .filter(
                          (c) => parseInt(c.id) === parseInt(cm.cabang_id)
                        )
                        .map((c) => c.nama)}
                  </td>
                  <td className="py-1 border-silver text-nowrap">
                    {departemen.length > 0 &&
                      departemen
                        .filter(
                          (d) => parseInt(d.id) === parseInt(cm.departemen_id)
                        )
                        .map((c) => c.nama)}
                  </td>
                  <td className="py-1 border-silver text-nowrap">
                    {auditor.length > 0 &&
                      auditor
                        .filter(
                          (a) => parseInt(a.id) === parseInt(cm.auditor_id)
                        )
                        .map((c) => c.nama)}
                  </td>
                  <td className="py-1 border-silver text-nowrap text-center">{cm.tahun}</td>
                  <td className="py-1 border-silver text-nowrap text-center">{cm.tahap}</td>
                  <td className="py-1 border-silver text-nowrap text-center">{cm.kode_dokumen}</td>
                  <td className="py-1 border-silver text-nowrap text-center">{cm.revisi}</td>
                  <td className="py-1 border-silver text-nowrap text-center">{cm.tanggal_efektif}</td>
                  <td className="py-1 border-silver text-nowrap text-center">
                    <Link
                      className="btn btn-sm btn-primary-3 border-0 py-0 text-sm rounded mx-1"
                      to={`${mainUrl}/${cm.id}/report`}
                    >
                      <i className="fa fa-fw fa-sm fa-bullhorn"/> Report
                    </Link>
                  </td>
                </tr>
              );
            })
          ) : (
            <TableNoData col={10} isLoaded={isLoaded} />
          )}
        </tbody>
      </LayoutTable>
      <SectionPagination
        links={ceklistMonitoring.links}
        from={ceklistMonitoring.from}
        to={ceklistMonitoring.to}
        total={ceklistMonitoring.total}
        onChangePage={(res) => setPage(res)}
      />
    </>
  );
};

export default Auditee;
